import { TemplateElement, html, defineElement, classMap } from '@webtides/element-js';
import style from './page-teasers.css';
import '../page-teaser/page-teaser.js';

/**
 * @property {'grid' | 'list' | 'links'} variant
 * @property {PageTeaserProperties[]} pages
 * @property {string} element - Element identifier for tracking purposes
 */
export default class PageTeasers extends TemplateElement {
    constructor() {
        super({ styles: [style] });
    }

    properties() {
        return {
            variant: 'grid',
            pages: [],
            element: 'page teasers',
        };
    }

    template() {
        if (this.variant === 'links') {
            return html`<ul class="m-0 flex list-none flex-col gap-[16px] p-0">
                ${this.pages.map(
                    (page) =>
                        html`<li class="flex items-start gap-[8px]">
                            <mdx-icon-chevron-right
                                size="sm"
                                class="shrink-0 text-green-medium"
                            ></mdx-icon-chevron-right>
                            <a
                                href="${page.link}"
                                class="fix-body2 text-green-medium no-underline hover:underline"
                                element="${this.element}"
                                >${page.title}</a
                            >
                        </li>`,
                )}
            </ul>`;
        }

        const size = this.pages.length;

        const wrapperClasses = {
            'md:grid-cols-2 lg:grid-cols-3': size === 2,
            'lg:grid-cols-3': size === 3,
            'md:grid-cols-2': size > 3,
        };

        return html`<div class="grid gap-16 lg:gap-24 grid-cols-1 ${classMap(wrapperClasses)}">
            ${this.pages.map(
                (page, index) =>
                    html`<mb-page-teaser
                        variant="${size === 1 ? 'standalone' : 'default'}"
                        orientation="${size === 2 || this.variant === 'list' ? 'portrait' : 'landscape'}"
                        class="${size === 2 && index === 0 ? 'lg:col-span-2' : ''}"
                        highlight-desktop="${size === 2 && index === 0}"
                        .page="${page}"
                    ></mb-page-teaser>`,
            )}
        </div>`;
    }
}

defineElement('mb-page-teasers', PageTeasers);
